/* HCS search aliases (23 Oct 2026, Finbar).
 *
 * Shopify removed custom synonyms from Search & Discovery, so the store's own
 * search could not tell that a 6" fan is a 150mm fan, or that "6040" means
 * Gold Label 60/40. This file widens the query before it is sent, using the
 * OR that Shopify's storefront search already honours:
 *
 *   "6 inch fan"   ->  "6 inch fan OR 150mm fan"
 *   "12in filter"  ->  "12in filter OR 315mm filter OR 312mm filter OR ..."
 *   "leca"         ->  "leca OR clay pebbles"
 *
 * ⚑ EACH ALTERNATIVE IS THE WHOLE QUERY WITH ONE TERM SWAPPED, so every branch
 * still ends on the shopper's own last word. sections/hcs-search-page.liquid
 * reads the LAST word as the head noun ("fan") to keep the results on-topic;
 * putting the alias at the end instead would make "150mm" the head noun and
 * the page would filter on that.
 *
 * Used by assets/predictive-search.js for the dropdown, and by the submit
 * listener below for the full results page. A query that already holds " OR "
 * is left alone, so the results page never widens its own query twice.
 */
(function () {
  'use strict';

  /* Inch -> mm, as UK ducting and fans are actually sold. 12" has no single
   * metric size: 315mm is the common duct, but 300/310/312mm all appear. */
  var IN_MM = {
    '1': ['25mm'], '2': ['50mm'], '3': ['75mm'], '4': ['100mm'], '5': ['125mm'],
    '6': ['150mm'], '8': ['200mm'], '10': ['250mm'],
    '12': ['315mm', '312mm', '310mm', '300mm'],
    '14': ['355mm'], '16': ['400mm'], '18': ['450mm'], '20': ['500mm'], '24': ['600mm']
  };
  var MM_IN = {};
  Object.keys(IN_MM).forEach(function (inch) {
    IN_MM[inch].forEach(function (mm) { MM_IN[mm] = inch; });
  });
  MM_IN['160mm'] = '6'; MM_IN['102mm'] = '4'; MM_IN['152mm'] = '6'; MM_IN['254mm'] = '10'; MM_IN['305mm'] = '12';

  /* Fan and duct sizes only - tent sizes in cm (120cm x 120cm) are not here. */
  var CM_MM = {
    '10cm': '100mm', '12.5cm': '125mm', '15cm': '150mm', '20cm': '200mm',
    '25cm': '250mm', '30cm': '315mm', '31.5cm': '315mm', '35.5cm': '355mm', '40cm': '400mm'
  };

  /* Whole-word aliases from searches that found nothing. */
  var WORDS = [
    [/\b60\s?40\b/i, 'gold label 60/40'],
    [/\beasy\s?(?:2|to)\s?go\b/i, 'easy2grow'],
    [/\beasy\s?to\s?grow\b/i, 'easy2grow'],
    [/\b(?:leca|hydroton|expanded clay|clay balls)\b/i, 'clay pebbles'],
    [/\bc02\b/i, 'co2'],
    [/\bgoose\s+neck\b/i, 'gooseneck']
  ];

  function sizeAlts(q) {
    var m;
    /* 6 inch / 6in / 6" / 6 inches */
    m = q.match(/\b(\d{1,2})\s*(?:inches|inch|in\b(?!\s*\d)|")/i);
    if (m && IN_MM[m[1]]) {
      return IN_MM[m[1]].map(function (mm) { return q.replace(m[0], mm); });
    }
    m = q.match(/\b(\d{2,3})\s*mm\b/i);
    if (m && MM_IN[m[1] + 'mm']) {
      return [q.replace(m[0], MM_IN[m[1] + 'mm'] + ' inch')];
    }
    m = q.match(/\b(\d{2}(?:\.\d)?)\s*cm\b/i);
    if (m && CM_MM[m[1] + 'cm']) {
      var mm = CM_MM[m[1] + 'cm'];
      return [q.replace(m[0], mm), q.replace(m[0], MM_IN[mm] + ' inch')];
    }
    return [];
  }

  function alias(q) {
    if (!q || / OR /.test(q)) return q;
    var s = String(q).trim();
    var alts = [];
    WORDS.forEach(function (w) {
      if (w[0].test(s)) alts.push(s.replace(w[0], w[1]));
    });
    alts = alts.concat(sizeAlts(s));
    alts = alts.filter(function (a, i) { return a !== s && alts.indexOf(a) === i; }).slice(0, 4);
    return alts.length ? [s].concat(alts).join(' OR ') : s;
  }

  window.hcsSearchAlias = alias;

  /* Capture phase, so the query is widened before any form handler or the
   * browser's own submit reads it. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || !/\/search\/?$/.test(new URL(form.action, location.href).pathname)) return;
    var input = form.querySelector('input[name="q"]');
    if (input && input.value) input.value = alias(input.value);
  }, true);
})();
